'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdContactMail = function MdContactMail(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 20v-10h-13.2v10h13.2z m-13.2 10v-1.6c0-3.4-6.7-5.2-10-5.2s-10 1.8-10 5.2v1.6h20z m-10-20c-2.8 0-5 2.3-5 5s2.2 5 5 5 5-2.3 5-5-2.3-5-5-5z m23.2-5c1.8 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.6 3.4-3.4 3.4h-33.2c-1.8 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.6-3.4 3.4-3.4h33.2z m-1.6 8.4l-5 3.2-5-3.2v-1.8l5 3.4 5-3.4v1.8z' })
        )
    );
};

exports.default = MdContactMail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/contact-mail.js
// module id = 3201
// module chunks = 168707334958949